// extracted by mini-css-extract-plugin
export default {"list":"src-feature-ui-__transfer-list_list","header":"src-feature-ui-__transfer-list_header"};